  <div class="page-title-area">
      <img src="assets/images/deploy_banner.png" alt="Page Background" class="page-bg">
      <button class="back-arrow-btn" (click)="navigateToHome()">
          <i class="fas fa-chevron-left fa-2x"></i>
      </button>
      <div class="container">
          <div class="page-title-content">
              <h2>Seamless Apple Deployment & Integration</h2>
          </div>
      </div>
  
    <!--   <div class="page-shape">
          <div class="shape1"><img src="assets/images/shape/1.png" alt="shape" /></div>
          <div class="shape3"><img src="assets/images/shape/3.png" alt="shape" /></div>
          <div class="shape4"><img src="assets/images/shape/4.png" alt="shape" /></div>
          <div class="shape5"><img src="assets/images/shape/5.png" alt="shape" /></div>
          <div class="shape6"><img src="assets/images/shape/6.png" alt="shape" /></div>
      </div> -->
  </div>
  
  <section class="services-details-area ptb-100">
      <div class="container">
          <div class="scrives-item-2 mt-4 ">
              <div class="row align-items-center">
                  <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
                      <div class="services-img mb-qc ios-content">
                          <div class="circular-layout">
                              <div class="image-container">
                                <img src="assets/images/deployment1.png" alt="image" class="image-container-img"/>
                              </div>
                            </div>
                         <!--  <div class="image-wrapper">
                              <div class="background-shape shape1"></div>
                              <div class="background-shape shape2"></div>
                              <img src="assets/images/net2.png" alt="Person">
                          </div> -->
                      </div>
                  </div>
  
                  <div class="col-lg-6">
                    <h2 style="text-align: center;">Deployment & Integration</h2>

                    <p>Deploying Apple devices shouldn’t be complicated—and with Superior Digital, it isn’t. </p>
                    <p> We handle every step from provisioning and configuration to zero-touch deployment using Apple Business Manager and MDM solutions. </p>
                    <p>Our certified engineers ensure your Macs, iPads, and iPhones are fully integrated into your IT environment with minimal disruption.</p>
                    <p>Whether you’re scaling a startup or upgrading an enterprise fleet, we tailor the deployment to your business needs.</p>
                    <p>Get your Apple ecosystem up and running—quickly, securely, and efficiently.</p>
                </div>
              </div>
          </div>
  
      </div>
  </section>
  
  <div class="container mb-4">
      <div class="d-flex justify-content-end">
          <button class="btn back-btn" (click)="navigateToHome()">
              <i class="fas fa-arrow-left me-2"></i> Back to Home
          </button>
      </div>
  </div>
  